import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/shared/shared.service';
import { ordersService } from '../../services/orders.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { STATUS } from 'src/app/constants/status.constant';
import { DatePipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { RegisterService } from 'src/app/auth/container/registration-module/register.service';
import { PATTERNS } from 'src/app/constants/constants/constants';

@Component({
  selector: 'app-ne-add-order',
  templateUrl: './ne-add-order.component.html',
  styleUrls: ['./ne-add-order.component.css']
})
export class NeAddOrderComponent {
  vehicleTypeList:any
  jobForm: FormGroup;
  minDate: Date = new Date();
  routeList: any;
  editTrue: boolean = false;
  EditData: any;
  filters:any;
  accountIds: any;
  customerDetails: any;
  allCatagory: any;
  sendCatagoryId: any;
  materialTypeList: any;
  UserDetails: any;
  locationList: any;
  constructor(private fb: FormBuilder,public sharedService: SharedService,private ordersService : ordersService
    ,public dialogRef: DynamicDialogRef,private datePipe: DatePipe,
    public data: DynamicDialogConfig,    private registerService: RegisterService
    
  ) {
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!);
    this.UserDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    this.sendCatagoryId = this.setId();

    console.log(this.sendCatagoryId);
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString());
    
    this.getAccounts()
    this.vehicleType()
    this.getRoutes()
    this.getLocations()

    this.jobForm = this.fb.group({
      remarks: new FormControl(null),
      spotFlag:new FormControl(false),
      tonnage: new FormControl(null, Validators.required),
      accountId: new FormControl(null, Validators.required),
      fromDate: new FormControl(null,Validators.required),
      materialTypeId: new FormControl(null,Validators.required),
      contactName: new FormControl('', Validators.required),
      contactMobile: new FormControl('',  [Validators.required, Validators.pattern(PATTERNS.PHONE)]),
      // contactAlternateMobile: new FormControl(null , [Validators.required, Validators.pattern(PATTERNS.PHONE)]),
      contactEmail: new FormControl('', Validators.required),

      ascContactName: new FormControl('', Validators.required),
      ascContactMobile: new FormControl('', [Validators.required, Validators.pattern(PATTERNS.PHONE)]),
      ascContactEmail: new FormControl('', Validators.required),

      jobLineItems: this.fb.array([this.createJobLineItem()]),
      version: new FormControl(null)
    });
    console.log("data",data)
    setTimeout(() => {
      this.patchData(data);
    }, 500);
  }


ngOnInit(): void {
    // Watch for spotFlag changes
    this.jobForm.get('spotFlag')?.valueChanges.subscribe((flag: boolean) => {
      this.updateValidators(flag);
    });

    // Set initial validators
    this.updateValidators(this.jobForm.get('spotFlag')?.value);
}
  private updateValidators(flag: boolean): void {
    console.log("flag",flag)
    const routeId = this.jobForm.get('routeId');
    const sourceText = this.jobForm.get('sourceText');
    const destinationText = this.jobForm.get('destinationText');

    if (flag === false) {
      // Contract => only Route required
      routeId?.setValidators([Validators.required]);
      this.jobForm.get('sourceText')?.reset();
    this.jobForm.get('destinationText')?.reset();
    } else {
      // Spot => Source & Destination required
      this.jobForm.get('routeId')?.reset();
      sourceText?.setValidators([Validators.required]);
      destinationText?.setValidators([Validators.required]);
    }

    // Update validity
    routeId?.updateValueAndValidity();
    sourceText?.updateValueAndValidity();
    destinationText?.updateValueAndValidity();
  }

  // Create JobLineItem
  createJobLineItem(): FormGroup {
    return this.fb.group({
      // id: [0],
      vehicleTypeId: ['',Validators.required],
      routeId: [''],
      sourceId: [''],
      sourceText: [''],
      destinationText: [''],
      destinationId: [''],
      maxSalary: [''],
      vendorPrice: [''],
      vehicleProvide: [''],
      numberOfVehicle: ['',Validators.required],
      sourceCities: this.fb.array([this.createSourceCity()]),
      destinationCities: this.fb.array([this.createDestinationCity()])
    });
  }

  // Create Source City
  createSourceCity(): FormGroup {
    return this.fb.group({
      sourceCityId: [''],
      sourceCity: [''],
      pincode: ['',Validators.required],
      address:['',Validators.required],
      city:['',Validators.required],
      stateName:['']
    });
  }

  // Create Destination City
  createDestinationCity(): FormGroup {
    return this.fb.group({
      destinationCityId: [''],
      destinationCity: [''],
      pincode: ['',Validators.required],
      address:['',Validators.required],
      city:['',Validators.required],
      stateName:['']
    });
  }

  // Getters
  get jobLineItems(): FormArray {
    return this.jobForm.get('jobLineItems') as FormArray;
  }

  getSourceCities(jobIndex: number): FormArray {
    return this.jobLineItems.at(jobIndex).get('sourceCities') as FormArray;
  }

  getDestinationCities(jobIndex: number): FormArray {
    return this.jobLineItems.at(jobIndex).get('destinationCities') as FormArray;
  }

  // Add / Remove Functions
  addJobLineItem() {
    this.jobLineItems.push(this.createJobLineItem());
  }

  removeJobLineItem(index: number) {
    if (this.jobLineItems.length > 1) {
      this.jobLineItems.removeAt(index); // removes only that one job
    }
  }
  addSourceCity(jobIndex: number) {
    this.getSourceCities(jobIndex).push(this.createSourceCity());
  }

 removeSourceCity(jobIndex: number, cityIndex: number) {
    if (this.getSourceCities(jobIndex).length > 1) {
      this.getSourceCities(jobIndex).removeAt(cityIndex); // removes only one
    }
  }

  addDestinationCity(jobIndex: number) {
    this.getDestinationCities(jobIndex).push(this.createDestinationCity());
  }

  removeDestinationCity(jobIndex: number, cityIndex: number) {
    if (this.getDestinationCities(jobIndex).length > 1) {
      this.getDestinationCities(jobIndex).removeAt(cityIndex); // removes only one
    }
  }

  // Submit
  onSubmit() {
    console.log(this.jobForm.value);
    const formValue = this.jobForm.value;
    const payload = {
      ...formValue,
      status: STATUS.Created,
      // spotFlag: false,
      fromDate: formValue.fromDate 
        ? this.datePipe.transform(formValue.fromDate, 'dd-MM-yyyy HH:mm:ss Z') 
        : null,
      // toDate: formValue.toDate 
      //   ? this.datePipe.transform(formValue.toDate, 'dd-MM-yyyy HH:mm:ss Z') 
      //   : null
    };



    // ✅ If edit, attach IDs
  if (this.editTrue && this.EditData) {
    payload.id = this.EditData.id ?? null;

    payload.jobLineItems = formValue.jobLineItems.map((item: any, i: number) => {
      const editItem = this.EditData.jobLineItems?.[i];
      return {
        ...item,
        id: editItem?.id ?? null,
        sourceCities: item.sourceCities.map((city: any, j: number) => {
          const editCity = editItem?.sourceCities?.[j];
          return {
            ...city,
            id: editCity?.id ?? null,
            sourceCityId: editCity?.sourceCityId ?? city.sourceCityId
          };
        }),
        destinationCities: item.destinationCities.map((city: any, j: number) => {
          const editCity = editItem?.destinationCities?.[j];
          return {
            ...city,
            id: editCity?.id ?? null,
            destinationCityId: editCity?.destinationCityId ?? city.destinationCityId
          };
        })
      };
    });
  }
  
  
  
     this.ordersService.addOrUpdate(payload).subscribe((data: any) => {
      if (data) {
        // this.orderData = data?.responseObject;
        
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    });
  }

 getAccounts() {
    // this.filters = [{ key: 'ACCOUNT_ID_IN', value: this.accountIds.join(',') }];
    this.ordersService.getAccounts([], 0, 100, 'id', 'DESC').subscribe(
      (data: any) => {
        this.customerDetails = data?.responseObject?.content;
        console.log(this.customerDetails);
        if(this.customerDetails?.length == 1)
         this.jobForm.patchValue({
          accountId:this.customerDetails[0]?.id,
         })
      },
      (err) => {
        this.customerDetails = [];
      }
    );
  }
vehicleType() {
  this.ordersService.getVehicleType([],0,500).subscribe((data: any) => {
    console.log(data?.responseObject);
    this.vehicleTypeList = data?.responseObject?.content;
  });
}
getLocations() {
  this.ordersService.getLocations([],0,500).subscribe((data: any) => {
    console.log(data?.responseObject);
    this.locationList = data?.responseObject?.content;
  });
}
getRoutes() {
  this.ordersService.getRoutes([],0,500).subscribe((data: any) => {
    console.log(data?.responseObject);
    this.routeList = data?.responseObject?.content;
  });
}  
 setId(): (number | undefined)[] {
    const keys = ['materialType'];
    return keys.map((key) => this.allCatagory?.[key]?.id);
  }
  getQuickCodeListByCategoryId(ids: any) {
    this.registerService
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        console.log(data?.responseObject);
        this.materialTypeList = data?.responseObject?.materialType;
      });
  }

// ================= Patch Data =================
  patchData(data: any) {
    this.editTrue = data?.data?.edit;
    if (data && data?.data && data?.data?.editData && data?.data?.edit) {
      if (data?.data?.editData.length === 1) {
        this.EditData = data?.data?.editData[0];
        console.log('EditData', this.EditData);

        const fromDate = moment(this.EditData?.fromDate, 'DD-MM-YYYY HH:mm:ss Z').toDate();
        const toDate = moment(this.EditData?.toDate, 'DD-MM-YYYY HH:mm:ss Z').toDate();

        // ✅ Patch main values
        this.jobForm.patchValue({
          tonnage: this.EditData?.tonnage,
          accountId:this.EditData?.accountId,
          materialTypeId: this.EditData?.materialTypeId,
          contactName: this.EditData?.contactName,
          contactEmail: this.EditData?.contactEmail,

          ascContactName: this.EditData?.ascContactName,
          ascContactMobile: this.EditData?.ascContactMobile,
          ascContactEmail: this.EditData?.ascContactEmail,

          // contactAlternateMobile: this.EditData?.contactAlternateMobile,
          contactMobile: this.EditData?.contactMobile,
          remarks: this.EditData?.remarks,
          spotFlag:this.EditData?.spotFlag ? true : false,
          fromDate: fromDate,
          version: this.EditData?.version || this.EditData?.version == 0 ? this.EditData?.version : null
        });

        // ✅ Patch JobLineItems
        const jobLineItemsFA = this.jobForm.get('jobLineItems') as FormArray;
        jobLineItemsFA.clear();

        this.EditData?.jobLineItems?.forEach((item: any) => {
          jobLineItemsFA.push(this.fb.group({
            vehicleTypeId: [item.vehicleTypeId],
            sourceId:[item.sourceId],
            destinationId:[item.destinationId],
            sourceText:[item.sourceText],
            destinationText:[item.destinationText],
            routeId: [item.routeId],
            maxSalary: [item.maxSalary],
            vendorPrice: [item.vendorPrice],
            vehicleProvide: [item.vehicleProvide],
            numberOfVehicle: [item.numberOfVehicle],
            sourceCities: this.buildSourceCities(item.sourceCities),
            destinationCities: this.buildDestinationCities(item.destinationCities)
          }));
        });

      } else {
        this.EditData = data?.data?.editData;
      }
    }
  }
 // ================= Helpers =================
buildSourceCities(sourceCities: any[]): FormArray<FormGroup> {
  const fa = this.fb.array<FormGroup>([]);
  sourceCities?.forEach(city => {
    fa.push(this.fb.group({
        pincode: [city.pincode],
        city: [city.city],
        address: [city.address]
      }));
    });
    return fa;
  }

  buildDestinationCities(destinationCities: any[]): FormArray<FormGroup> {
  const fa = this.fb.array<FormGroup>([]);
  destinationCities?.forEach(city => {
    fa.push(this.fb.group({
        pincode: [city.pincode],
        city: [city.city],
        address: [city.address]
      }));
    });
    return fa;
  }


onSelectRoute(id:any){
  // console.log("pppppppp",id)
    const item = this.routeList.find((item: any) => item.id == id);

  console.log("item",item)
  // const jobLineItemsFA = this.jobForm.get('jobLineItems') as FormArray;

  // // this.EditData?.jobLineItems?.forEach((item: any) => {
  // jobLineItemsFA.push(this.fb.group({

  //   // Pick only names from objects
  //   sourceCities: [item.sourceCities?.map((c: any) => c.sourceCity) || []],
  //   destinationCities: [item.destinationCities?.map((c: any) => c.destinationCity) || []]
  // }));
// });

}
}
